import { useEffect } from 'react';
import { getEquipment, getUnit } from 'api/unity';
import { useMinifiedMenu } from './useMinifiedMenu';

export const useAutoUpdateWidgets = () => {
  const { minifiedMenuItems, setMinifiedMenuItems } = useMinifiedMenu();

  useEffect(() => {
    const updateWidgets = async () => {
      for (const entry of minifiedMenuItems) {
        for (const menuItem of entry.data) {
          if (menuItem.type === 'widget') {
            const { bubbleAllDetails } = menuItem.data;
            const id = bubbleAllDetails?.equipmentId || bubbleAllDetails?.unitId;
            const fetchData = bubbleAllDetails?.equipmentId ? getEquipment : getUnit;
            if (!id) continue;

            try {
              const response = await fetchData(id);
              if (response.status === 200) {
                const newChartData = response.data?.tags ?? [];
                setMinifiedMenuItems((prevState) =>
                  prevState.map((e) =>
                    e.position === entry.position
                      ? {
                        ...e,
                        data: e.data.map((item) =>
                          item.data.bubbleAllDetails?.equipmentId === id ||
                            item.data.bubbleAllDetails?.unitId === id
                            ? { ...item, data: { ...item.data, chartData: newChartData } }
                            : item
                        ),
                      }
                      : e
                  )
                );
              }
            } catch (error) {
              console.error('Error fetching widget data:', error);
            }
          }
        }
      }
    };

    const interval = setInterval(updateWidgets, 60000);
    return () => clearInterval(interval);
  }, [minifiedMenuItems, setMinifiedMenuItems]);
};